// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CustomSidebar from "../../../pricing-dashboard/view/components/library/reuseable-components/CustomSidebar.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as PartnerPenaltiesSM from "../../app/state-machine/PartnerPenaltiesSM.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as PartnerPenaltyListCmp from "./PartnerPenaltyListCmp.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as DeletePartnerPenaltyCmp from "./DeletePartnerPenaltyCmp.bs.js";
import * as FetchPartnerPenaltiesForm from "./FetchPartnerPenaltiesForm.bs.js";
import * as PartnerPenaltyDataMachine from "../../app/data-machine/PartnerPenaltyDataMachine.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as PartnerPenaltyAssetsManager from "../assets/PartnerPenaltyAssetsManager.bs.js";
import * as FetchPartnerPenaltiesFormCmp from "./FetchPartnerPenaltiesFormCmp.bs.js";

PartnerPenaltyAssetsManager.importCss(undefined);

function PartnerPenaltiesContainer(Props) {
  var msisdn = Props.msisdn;
  var crn = Props.crn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowDeletePenaltyPanel = match$1[1];
  var match$2 = React.useState(function () {
        
      });
  var setSelectedPenalty = match$2[1];
  var match$3 = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match$3[1];
  var match$4 = React.useState(function () {
        return false;
      });
  var toggleLoader = match$4[1];
  var match$5 = React.useReducer(PartnerPenaltiesSM.machine, /* Init */0);
  var partnerPenaltiesDispatch = match$5[1];
  var partnerPenaltiesState = match$5[0];
  var openDeletePenaltyPanel = function (penalty) {
    Curry._1(setShowDeletePenaltyPanel, (function (param) {
            return true;
          }));
    return Curry._1(setSelectedPenalty, (function (param) {
                  return penalty;
                }));
  };
  var closeDeletePenaltyPanel = function (param) {
    Curry._1(setShowDeletePenaltyPanel, (function (param) {
            return false;
          }));
    return Curry._1(setSelectedPenalty, (function (param) {
                  
                }));
  };
  var fetchPartnerPenalties = function (order_crn, msisdn, start_date, end_date) {
    Curry._1(toggleLoader, (function (param) {
            return true;
          }));
    return PartnerPenaltyDataMachine.fetchPartnerPenalties(order_crn, msisdn, start_date, end_date, country, (function (data) {
                  Curry._1(toggleLoader, (function (param) {
                          return false;
                        }));
                  return Curry._1(partnerPenaltiesDispatch, {
                              TAG: /* FetchPartnerPenaltiesSuccess */0,
                              _0: data
                            });
                }), (function (error) {
                  Curry._1(toggleLoader, (function (param) {
                          return false;
                        }));
                  Curry._1(partnerPenaltiesDispatch, {
                        TAG: /* FetchPartnerPenaltiesFailure */1,
                        _0: error
                      });
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                }));
  };
  var form = FetchPartnerPenaltiesForm.Form.useForm(FetchPartnerPenaltiesForm.getInitialInput(crn, msisdn), {
        country: country
      }, (function (output, submissionCbs) {
          fetchPartnerPenalties(output.crn, output.msisdn, output.start_date, output.end_date);
          return Curry._1(submissionCbs.notifyOnSuccess, undefined);
        }));
  var deletePenalty = function (penalty_id, comment) {
    Curry._1(toggleLoader, (function (param) {
            return true;
          }));
    return PartnerPenaltyDataMachine.deletePartnerPenalty({
                penalty_id: penalty_id,
                comment: comment
              }, country, (function (param) {
                  Curry._1(toggleLoader, (function (param) {
                          return false;
                        }));
                  Curry._1(openSnackbar, {
                        TAG: /* Success */0,
                        _0: "Penalty is deleted"
                      });
                  Curry._1(setShowDeletePenaltyPanel, (function (param) {
                          return false;
                        }));
                  Curry._1(setSelectedPenalty, (function (param) {
                          
                        }));
                  return Curry._1(form.submit, undefined);
                }), (function (error) {
                  Curry._1(toggleLoader, (function (param) {
                          return false;
                        }));
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                }));
  };
  React.useEffect((function () {
          if (crn !== undefined) {
            fetchPartnerPenalties(crn, msisdn, undefined, undefined);
          }
          
        }), []);
  var tmp;
  tmp = typeof partnerPenaltiesState === "number" || partnerPenaltiesState.TAG !== /* Data */0 ? null : React.createElement(PartnerPenaltyListCmp.make, {
          tableData: partnerPenaltiesState._0,
          workspace_dispatch: workspaceDispatch,
          openDeletePenaltyPanel: openDeletePenaltyPanel
        });
  return React.createElement("div", {
              className: "c-driver-penalty-list-container"
            }, React.createElement("div", {
                  className: "title"
                }, "Penalty List of Driver"), React.createElement("div", {
                  className: "desc"
                }, "Get penalty list based on either MSISDN or Order ID"), React.createElement(FetchPartnerPenaltiesFormCmp.make, {
                  form: form
                }), React.createElement("div", {
                  className: "penalty-list-table"
                }, tmp), React.createElement(CustomSidebar.make, {
                  is_open: match$1[0],
                  on_back_drop_click: (function (param) {
                      Curry._1(setShowDeletePenaltyPanel, (function (param) {
                              return false;
                            }));
                      return Curry._1(setSelectedPenalty, (function (param) {
                                    
                                  }));
                    }),
                  children: React.createElement(DeletePartnerPenaltyCmp.make, {
                        selected_penalty: match$2[0],
                        close_deletePenalty_panel: closeDeletePenaltyPanel,
                        delete_penalty: deletePenalty
                      })
                }), match$4[0] ? React.createElement(CircularLoader$Catalyst.make, {}) : null, match$3[0]);
}

var make = PartnerPenaltiesContainer;

export {
  make ,
  
}
/*  Not a pure module */
